import { mount } from 'svelte';

import './styles/app.css';
import App from './app/App.svelte';

const target = document.getElementById('app');
if (target === null) {
  throw new Error('index.html is missing the #app mount point');
}

export default mount(App, { target });
